import $ from 'jquery';
import widgetFactory from '../../widgetFactory';

import COUNTRY_WITHOUT_ZIPCODE_LIST from './countryWithoutZipCode.json';

import postalCodes from 'postal-codes-js';

const widgetName = 'zipCodeValidator',
  baseClassname = 'js-zipCodeValidator';

export default widgetFactory(widgetName, {
  options: {
    countrySelector: '[name*=\\[country\\]]',
    zipCodeSelector: '[name*=\\[zipCode\\]]',
    errorMessage: '.js-zipCodeError',
  },

  _create() {
    this._super(baseClassname);
    this._getElements();
    this._attachEvents();

    this.check();
  },

  _attachEvents() {
    const { $country, $zipCode } = this.elements;

    $country.on('change', (e) => {
      this.check();
    });

    $zipCode.on('blur', (e) => {
      this.check();
    });
  },

  _getElements() {
    this.elements.$country = $(this.options.countrySelector, this.element);
    this.elements.$zipCode = $(this.options.zipCodeSelector, this.element);
    this.elements.$errorMessage = $(this.options.errorMessage, this.element);
  },

  _toggleSelect($element, state) {
    let $select = $element;

    if (!$element.is('select')) {
      $select = $element.find('select');
    }

    $element.toggle(state);
    $select.prop('required', state);
  },

  check() {
    const listCountryWithoutZipCode = COUNTRY_WITHOUT_ZIPCODE_LIST.countryWithoutZipCode;
    let { elements } = this,
      currentCountry = elements.$country.val(),
      currentZipCode = elements.$zipCode.val(),
      $showMessage = elements.$errorMessage,
      $submitButton = elements.$container.parent().find('.js-subscription-submit'),
      $zipcodeRequiredStar = elements.$container
        .parent()
        .find('.js-zipCode')
        .find('.js-form-required.zipCode'),
      isValid = postalCodes.validate(currentCountry, currentZipCode);

    elements.$zipCode.prop('required', true);
    $zipcodeRequiredStar.show();

    listCountryWithoutZipCode.map((countryWithoutZipCode) => {
      if (currentCountry === countryWithoutZipCode) {
        $zipcodeRequiredStar.hide();
        elements.$zipCode.removeAttr('required');
      }
    });

    if (isValid !== true && currentZipCode !== '') {
      $showMessage.show();
      $submitButton.prop('disabled', true);
    } else {
      $showMessage.hide();
      $submitButton.prop('disabled', false);
    }
  },
});
